import type { Profile } from "@spork/s4p-server-sdk";

export type ProfileBadgeKey = "child" | "you" | "other" | "parent";

export function getProfileBadge(
    profile: Profile,
    parentPipedriveId: number | null,
): ProfileBadgeKey {
    if (profile.role === "student") {
        return "child";
    }

    if (parentPipedriveId != null && profile.id === parentPipedriveId) {
        return "you";
    }

    if (profile.role === "other") {
        return "other";
    }

    return "parent";
}
